import moment from "moment";

export const getBillingDateRange = () => {
  const today = moment();
  const fifthDayOfMonth = moment().date(1);
  let startDate, endDate;

  // บังคับให้ startDate เป็นวันที่ 5 ของเดือนที่แล้วเสมอ
  startDate = moment().subtract(0, "month").date(1);

  if (today.isAfter(fifthDayOfMonth, "day")) {
    // ถ้าเลยวันที่ 5 มาแล้ว วันสิ้นสุดคือวันที่ 5 ของเดือนหน้า
    endDate = moment().add(1, "month").date(1);
  } else {
    // ถ้ายังไม่เลยวันที่ 5 วันสิ้นสุดคือวันที่ 5 ของเดือนปัจจุบัน
    endDate = moment().date(1);
  }

  // จัดรูปแบบวันที่ให้อ่านง่ายเป็นภาษาไทย
  const formattedStartDate = startDate.locale("th").format("ll");
  const formattedEndDate = endDate.locale("th").format("ll");

  return {
    // startDate ปรับตามโจทย์คือ -1 เดือนจากปัจจุบัน
    startDate: startDate.locale("th").format("lll"),
    endDate: endDate.locale("th").format("lll"),
    objectDate: {
      startDate: startDate.format("YYYY-MM-DD"),
      endDate: endDate.format("YYYY-MM-DD"),
    },
    note: `ตั้งแต่วันที่ ${formattedStartDate} - ${formattedEndDate}`,
  };
};